import { View, Text, Pressable, ActivityIndicator } from 'react-native';
import { matchSportViewStyles as styles } from './MatchSportView.styles';
import { MATCH_SPORT_ACCENT, MATCH_SPORT_TEST_IDS } from '../../../src/quiz/constants/matchSport.constants';

interface MatchSportOverlaysProps {
  status: 'loading' | 'ready' | 'error';
  onRetry: () => void;
}

/**
 * The host-side overlay layer: loading until the runtime posts `ready`, error + Retry on
 * `load-error`. Everything else (map, briefing, board, win/lose screens) is the game's own UI.
 */
export function MatchSportOverlays({ status, onRetry }: MatchSportOverlaysProps) {
  if (status === 'loading') {
    return (
      <View style={styles.overlay} testID={MATCH_SPORT_TEST_IDS.loading} pointerEvents="none">
        <ActivityIndicator color={MATCH_SPORT_ACCENT} />
      </View>
    );
  }
  if (status === 'error') {
    return (
      <View style={styles.overlay} testID={MATCH_SPORT_TEST_IDS.error}>
        <Text style={styles.message}>Could not load the game</Text>
        <Pressable
          testID={MATCH_SPORT_TEST_IDS.retry}
          onPress={onRetry}
          style={({ pressed }) => [styles.retryButton, pressed && styles.pressedDim]}
        >
          <Text style={styles.retryText}>Retry</Text>
        </Pressable>
      </View>
    );
  }
  return null;
}
